import React from "react";
import PageHeader from "src/componets/PageHeader";
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../../../../helpers/UrlHelpers";

const _PageHeader: React.FC = () => {
  const [searchParams] = useSearchParams();
  const type = (queryParams.get(searchParams,'state') || 'All').replace('_', ' ');

  return <PageHeader title='Challenges' breadcrumbs={[type]}/>;
}

export default _PageHeader;
